module.exports = __webpack_public_path__ + "static/media/Tura-IO.5703e48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/screenshots/Tura-IO.png
// module id = 94
// module chunks = 0